export enum FeatureName {
  LINKED_WEARABLES_V2 = 'linked-wearables-v2'
}
